/** "42.25" (hours, as the payroll API sends them) → "42h 15m". Anything unreadable comes back as given. */
export function formatHours(raw: string): string {
  const hours = Number(raw);
  if (!Number.isFinite(hours) || hours < 0) return raw;
  const totalMinutes = Math.round(hours * 60);
  return `${Math.floor(totalMinutes / 60)}h ${String(totalMinutes % 60).padStart(2, "0")}m`;
}
